// extracted by mini-css-extract-plugin
export var container = "PlayerModal-module--container--5e001";
export var closeBtn = "PlayerModal-module--closeBtn--cdca6";